import { render, staticRenderFns } from "./RaceStats.vue?vue&type=template&id=05af6620&scoped=true&"
import script from "./RaceStats.vue?vue&type=script&lang=js&"
export * from "./RaceStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af6620",
  null
  
)

export default component.exports